// src/pages/AuthRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import "../assets/css/auth-redirect.css"; // 👈 Đừng quên tạo file này
const clientUrl = process.env.REACT_APP_CLIENT_URL || "http://localhost:3001";

const AuthRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const username = params.get("username");
    const email = params.get("email");
    const role = params.get("role");

    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify({ username, email, role }));

      setTimeout(() => {
        navigate("/dashboard");
      }, 1000); // ⏱ Delay nhẹ để UX mượt
    } else {
        window.location.href = `${clientUrl}/login-register`;
    }
  }, [navigate]);

  return (
    <div className="auth-redirect-container">
      <FaSpinner className="auth-spinner" />
      <p>Đang chuyển hướng đến trang quản trị...</p>
    </div>
  );
};

export default AuthRedirect;
